import { render, staticRenderFns } from "./questionFour.vue?vue&type=template&id=c8d1dbc0&scoped=true"
import script from "./questionFour.vue?vue&type=script&lang=js"
export * from "./questionFour.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/quesstion.css?vue&type=style&index=0&id=c8d1dbc0&prod&scoped=true&lang=css&external"
import style1 from "./questionFour.vue?vue&type=style&index=1&id=c8d1dbc0&prod&scoped=true&lang=css"
import style2 from "./questionFour.vue?vue&type=style&index=2&id=c8d1dbc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d1dbc0",
  null
  
)

export default component.exports